import { firebase_Db } from "../../src/config/firebaseConfig";

const DBName = "orders";
const DBorders = "delivererOrders";

const deleteOrders = async (id) => {
  return await firebase_Db.collection(DBName).doc(id).delete();
};

const getOrders = async () => {
  return await firebase_Db
    .collection(DBName)
    .orderBy("dateCreated", "desc")
    .get();
};

const getDeliveredOrders = async () => {
  return await firebase_Db
    .collection(DBorders)
    .orderBy("dateCreated", "desc")
    .get();
};

const adddeliveredOrders = async ({
  user_data,
  order_products,
  delivered = true,
}) => {
  const ref = firebase_Db.Collection(DBorders).doc();
  return await firebase_Db.Collection(DBorders).add({
    id: ref.id,
    user: user_data,
    products_order: order_products,
    delivered: delivered,
  });
};

export { deleteOrders, getOrders, adddeliveredOrders, getDeliveredOrders };
